// extracted by mini-css-extract-plugin
export default {"tabs":"H--z","tablist":"I--z","tablistItem":"J--z"};